/*
 * @Author: your name
 * @Date: 2020-06-30 16:08:40
 * @LastEditTime: 2021-04-14 15:19:48
 * @LastEditors: wangwangwang
 * @Description: In User Settings Edit
 * @FilePath: \icps_baseWeb\src\api\basedata\function.js
 */
import request from '@/utils/request'
export const Download = "/base/system/function/manager/export";

export function getTreeList(params) {
  return request({
    url: '/base/system/function/manager/get_list',
    method: 'get',
    params
  })
}
export function queryPage(data) {
  return request({
    url: '/base/system/function/manager/queryPage',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/function/manager/save_or_update',
    method: 'post',
    data
  })
}
export function getDetail(data) {
  return request({
    url: '/base/system/function/manager/get_detail',
    method: 'post',
    data
  })
}
export function batchUpdateOrDelete(data) {
  return request({
    url: '/base/system/function/manager/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/base/system/function/manager/update_sort_num',
    method: 'post',
    data
  })
}
// export function getFunctionButtonList(params) {
//   return request({
//     url: '/base/system/function/manager/get_function_button_list', 
//     method: 'get',
// 	params
//   })
// }
export function buttonsaveOrUpdate(data) {
  return request({
    url: '/base/system/function/button/save_or_update',
    method: 'post',
    data
  })
}
export function ButtongetList(params) {
  return request({
    url: '/base/system/function/button/get_list',
    method: 'get',
    params
  })
}
/**移动*/
export function move(params) {
  return request({
    url: '/base/system/function/manager/batch_move',
    method: 'get',
    params
  })
}